'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUngatedForTroubleshooting = exports.isUngatedForFifteenMinuteStartTimes = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _gates = require('MeetingsLib/constants/gates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBookInfo = (0, _get2.default)('bookInfo');

var getOpenGates = (0, _reselect.createSelector)([getBookInfo], function (bookInfo) {
  return bookInfo.openGates;
});

var isUngatedForFifteenMinuteStartTimes = exports.isUngatedForFifteenMinuteStartTimes = (0, _reselect.createSelector)([getOpenGates], function (openGates) {
  return openGates.includes(_gates.FIFTEEN_MINUTE_START_TIMES_GATE);
});

var isUngatedForTroubleshooting = exports.isUngatedForTroubleshooting = (0, _reselect.createSelector)([getOpenGates], function (openGates) {
  return openGates.includes(_gates.TROUBLESHOOT_GATE);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/GateSelectors.js
// module id = 184
// module chunks = 0